export enum Roles {
  Restricted = "Restricted",
  User = "User",
  SystemAdmin = "SystemAdmin",
  OrganizationAdmin = "OrganizationAdmin",
  Instructor = "Instructor"
}

export enum CampaignType {
  Sandbox = "Sandbox",
  Learn = "Learn",
  Compete = "Compete",   
}

export enum ScenarioType {
  Globe = "Globe",
  Presentation = "Presentation",
  Quiz = "Quiz"
}

export enum ScoreCardType {
  Default = "Default",
  Quiz = "Quiz"
}